import React, { useEffect, useState } from "react"
import { FormDataResponse } from "../../../@types/DRO/FormSubmissionResponse"
import { FormDatasSubmission } from "../../../api/FormData/FormDataSubmissionApi"
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Tooltip,
    Modal,
    Box,
} from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightToBracket, faEye } from "@fortawesome/free-solid-svg-icons" // Import the eye icon

interface VisitorTableProps {
    status: string
    startDate: Date | null | string
    endDate: Date | null | string
    onExitClick: (visitor: FormData) => void
    visitorData: any[]
}

const VisitorTable: React.FC<VisitorTableProps> = ({
    status,
    startDate,
    endDate,
    onExitClick,
    visitorData,
}) => {
    const [open, setOpen] = useState(false)
    const [imageUrl, setImageUrl] = useState<string | null>(null)

    const handleViewFile = async (fileId: number) => {
        try {
            const fileBlob = await FormDatasSubmission.api.downLoadFile(fileId)
            const url = URL.createObjectURL(fileBlob)
            setImageUrl(url)
            setOpen(true)
        } catch (error) {
            console.error("Error fetching file URL:", error)
        }
    }

    const handleClose = () => {
        setOpen(false)
        setImageUrl(null)
    }

    return (
        <div className="flex-grow  bg-white rounded-lg shadow   pb-4">
            <div className="flex w-full justify-between mt-5 mb-3">
                <div className="w-full">
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ display: "flex" }}>
                                    <TableCell
                                        sx={{
                                            width: "50px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        ID
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "130px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Name
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "130px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Visit Date
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "150px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Contact Number
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "150px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Government ID
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "110px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Entry Time
                                    </TableCell>
                                    {status === "EXITED" && (
                                        <TableCell
                                            sx={{
                                                width: "110px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Exit Time
                                        </TableCell>
                                    )}
                                    <TableCell
                                        sx={{
                                            width: "150px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Address
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "130px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        To Meet
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "150px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Purpose
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "110px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        View File
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            width: "110px",
                                            position: "sticky",
                                            right: 0,
                                            background: "white",
                                            zIndex: 2,
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Status
                                    </TableCell>
                                    {status === "ENTERED" && (
                                        <TableCell
                                            sx={{
                                                width: "100px",
                                                position: "sticky",
                                                right: 0,
                                                background: "white",
                                                zIndex: 2,
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Action
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {visitorData &&
                                    Array.isArray(visitorData) &&
                                    visitorData.map((visitor: any) => (
                                        <TableRow
                                            key={visitor.id}
                                            sx={{ display: "flex" }}
                                        >
                                            <TableCell sx={{ width: "50px" }}>
                                                {visitor.id}
                                            </TableCell>
                                            <TableCell sx={{ width: "130px" }}>
                                                {visitor.visitorName}
                                            </TableCell>
                                            <TableCell sx={{ width: "130px" }}>
                                                {visitor.visitDate}
                                            </TableCell>
                                            <TableCell sx={{ width: "150px" }}>
                                                {visitor.contactNumber}
                                            </TableCell>
                                            <TableCell sx={{ width: "150px" }}>
                                                {visitor.govtIdNumber}
                                            </TableCell>
                                            <TableCell sx={{ width: "110px" }}>
                                                {visitor.entryTime}
                                            </TableCell>
                                            {status === "EXITED" && (
                                                <TableCell
                                                    sx={{ width: "110px" }}
                                                >
                                                    {visitor.exitTime}
                                                </TableCell>
                                            )}
                                            <TableCell sx={{ width: "150px" }}>
                                                {visitor.address}
                                            </TableCell>
                                            <TableCell sx={{ width: "130px" }}>
                                                {visitor.toMeet}
                                            </TableCell>
                                            <TableCell sx={{ width: "150px" }}>
                                                {visitor.purpose}
                                            </TableCell>
                                            <TableCell sx={{ width: "110px" }}>
                                                <Tooltip title="View File">
                                                    <Button
                                                        onClick={() =>
                                                            handleViewFile(
                                                                visitor.photoId
                                                            )
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faEye}
                                                        />
                                                    </Button>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    width: "110px",
                                                    position: "sticky",
                                                    right: 0,
                                                    background: "white",
                                                    zIndex: 2,
                                                }}
                                            >
                                                {visitor.status}
                                            </TableCell>
                                            {status === "ENTERED" && (
                                                <TableCell
                                                    sx={{
                                                        width: "100px",
                                                        position: "sticky",
                                                        right: 0,
                                                        background: "white",
                                                        zIndex: 2,
                                                    }}
                                                >
                                                    <Button
                                                        sx={{ color: "red" }}
                                                        onClick={() =>
                                                            onExitClick(visitor)
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={
                                                                faArrowRightToBracket
                                                            }
                                                        />
                                                    </Button>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {imageUrl && (
                        <img
                            src={imageUrl}
                            alt="Visitor File"
                            style={{ width: "100%", height: "auto" }}
                        />
                    )}
                </Box>
            </Modal>
        </div>
    )
}

export default VisitorTable
